import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exit-nav",
  "use": "exit-nav-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"exit-nav\">\n<rect x=\"2.12207\" y=\"0.707351\" width=\"29\" height=\"2\" rx=\"0.5\" transform=\"rotate(45 2.12207 0.707351)\" fill=\"black\" stroke=\"black\" />\n<rect x=\"22.6279\" y=\"2.12134\" width=\"29\" height=\"2\" rx=\"0.5\" transform=\"rotate(135 22.6279 2.12134)\" fill=\"black\" stroke=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol